<template>
    <div id="myAppliances">
      <div id="content">

        <patternlib-headline :headline="$t('menuBar.myAppliances')" separator="none" heading-tag="h2"></patternlib-headline>
        <Appliance v-if="globalStore.appliances && getAppliancesExecutionDone" v-for="(appliance, index) in globalStore.appliances"
          :name = "appliance.nickname"
          :designation = "appliance.designation"
          :serialnumber = "appliance.serialnumber"
          :servicenumber = "appliance.servicenumber"
          :pictureSRC = "appliance.pictureSRC"
          @deleteAppliance="(event) => {confirmDeleteAppliance(event)}"
          @changeNickname="(event) => {editNickname(event)}"
        ></Appliance>

        <registerApplianceBanner :has-appliances="hasAppliances" />
      </div>
      <div 
        style="
          width: 100%;
          display: flex;
          align-content: center;
          justify-content: center;
        "
        v-if="!getAppliancesExecutionDone"
      >
        <patternlib-spinner spin/>
      </div>

      <patternlib-modal 
        :modal-title="$t('appliance.delete')"
        :cancel-label="$t('modalAppliance.cancel')"
        :confirm-label="$t('appliance.delete')"
        cancel-type="secondary"
        :show="showDeleteAppliance"
        @lhClose="showDeleteAppliance = false"
        @lhCancel="showDeleteAppliance = false"
        @lhConfirm="(event) => {deleteAppliance()}"
      >
        <span slot="modal-content">
          {{ $t('modalAppliance.deletionText', {serialnumber: serialnumber, nickname: nickname}) }}
        </span>
      </patternlib-modal>
      <patternlib-modal 
        :modal-title="$t('appliance.changeNickname')"
        :cancel-label="$t('modalAppliance.cancel')"
        :confirm-label="$t('appliance.changeNickname')"
        cancel-type="secondary"
        :show="showChangeNickname"
        @lhClose="showChangeNickname = false"
        @lhCancel="showChangeNickname = false"
        @lhConfirm="(event) => {changeNickname()}"
      >
        <span slot="modal-content">
          <form>
            <patternlib-textinput 
              :label="$t('modalAppliance.changeNicknameLabel', {serialnumber: serialnumber, nickname: nickname})"
              :placeholder="nickname"
              maxlength="40"
              :warning-text="$t('modalAppliance.lengthNickname')"
              :error-text="$t('modalAppliance.noSpecialChars')"
              :status="nicknameState"
              ref="newNickname"
              @lhChange="((ev) => {nicknameState = (ev.detail.value.length >= 40 || ev.detail.value.length <= 0) ? 'warning' : ev.detail.value.match(/[^a-z|^A-Z|^ÄÖÜäöü|^\s]/, ' ') ? 'error' : 'default'})"
            />
          </form>
        </span>
      </patternlib-modal>
    </div>
</template>

<script>
import Appliance from "../components/appliance.vue"
import registerApplianceBanner from "../components/registerApplianceBanner.vue";
import { useServices } from "../services/useServices";
import { useGlobal } from "../stores/globalStore";

export default {
  data: () => ({
    serialnumber: "",
    nickname: "",
    nicknameState: "default",

    showDeleteAppliance: false,
    showChangeNickname: false,

    intervallId: null,

    getAppliancesExecutionDone: false,
    hasAppliances: false
  }),

  components: {
    Appliance,
    registerApplianceBanner
  },

    computed: {
      globalStore: () => useGlobal()
    },

  methods: {
    setAppliances (data, services, globalStore) {
      if (data != null) {
        if (data.length > 0) {
          this.hasAppliances = true;
        }

        data.forEach(appliance => {
          appliance.pictureSRC = appliance.pictureAvailable ? services.$api.getImageUrl(appliance.serialnumber) : ""
        });
        globalStore.appliances = data
      }
      else {
        globalStore.appliances = undefined
        this.$emit("showMessage", {
            type: "alert",
            autoHide: true,
            delay: 15000,
            showIcon: true,
            message: this.$t("unknownError")
        })
      }
      this.getAppliancesExecutionDone = true;
    },

    confirmDeleteAppliance(event) {
      this.serialnumber = event.serialnumber
      this.nickname = event.nickname
      this.showDeleteAppliance = true
    },

    deleteAppliance() {
      this.showDeleteAppliance = false;

      const services = useServices();
      
      services.$api.deleteAppliance((successful) => {
        if (successful) {
          this.$emit("showMessage", {
            type: "success",
            autoHide: true,
            delay: 15000,
            showIcon: true,
            message: this.$t("deleteAppliance.success")
          });
          this.loadAppliances();
        }
      },this.serialnumber)
    },

    editNickname(event) {
      this.serialnumber = event.serialnumber
      this.nickname = event.nickname
      this.showChangeNickname = true
    },

    changeNickname(){
      const services = useServices()
      services.$api.changeNickname((successful) => {
        this.showChangeNickname = false
        if (successful) {
          this.$emit("showMessage", {
            type: "success",
            autoHide: true,
            delay: 15000,
            showIcon: true,
            message: this.$t("changeNickname.success")
          });
          this.loadAppliances()
          return
        }
        this.$emit("showMessage", {
            type: "alert",
            showIcon: true,
            message: this.$t("unknownError")
        })
      }, this.serialnumber, this.$refs.newNickname.value.replace(/[^a-z|^A-Z|^ÄÖÜäöü]/g, " "))
    },

    loadAppliances() {
      const services = useServices()
      const globalStore = useGlobal()

      services.$api.getAppliances((data) => {        
        this.setAppliances(data, services, globalStore)
      });
    }
  },

  mounted() {
    const services = useServices()
    const globalStore = useGlobal()

    services.$api.getAppliances((data) => {      
      this.setAppliances(data, services, globalStore)
    })

    let enablePolling = (import.meta.env.VITE_POLLING_INTERVALL > 5)
    if (enablePolling){
      // this.intervallId = setInterval(() => {
      //   services.$api.getAppliances((data) => {
      //     if (data.length != globalStore.appliances.length) {
      //       this.setAppliances(data, services, globalStore)
      //     }
      //   })
      // }, process.env.VUE_POLLING_INTERVALL * 1000)
    }
  },

  unmounted() {
    clearInterval(this.intervallId)
  }
};
</script>

<style lang="scss" scoped>
#myAppliances {
    display: flex;
    flex-direction: column;
    align-items: center;
}

#content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 90%;
}

#registerAppliance {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-5);
  height: 262px;
  width: 100%;

  border-style: dashed;
  border-width: 1px;
  border-color: var(--color-black);
  background-color: var(--color-steel-100);

  margin: var(--spacing-6) 0px;
}


</style>